import React from 'react';
import { Router, Route, browserHistory } from 'react-router';
import { Provider } from 'react-redux';
import { syncHistoryWithStore } from 'react-router-redux';

import {
  FeatureFlagProvider,
  UnleashFeatureFlagProvider,
} from './FeatureFlagProvider';
import Layout from './Layout';
import createReduxStore from '../createReduxStore';
import Login from './Login';
import Register from './Register';
import RegisterComplete from './RegisterComplete';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import ResetGoBizPassword from './ResetGoBizPassword';
import ResetGoBizPasswordDone from './ResetGoBizPasswordDone';
import SuccessResetPassword from './SuccessResetPassword';
import SuccessForgotPassword from './SuccessForgotPassword';
import ResendVerificationEmail from './ResendVerificationEmail/ResendVerificationEmail';
import VerifyEmail from './VerifyEmail';

const store = createReduxStore();
const history = syncHistoryWithStore(browserHistory, store);

type Props = {
  location?: any;
};

class App extends React.Component<Props> {
  render() {
    return (
      <Provider store={store}>
        <FeatureFlagProvider>
          <UnleashFeatureFlagProvider>
            <Router history={history}>
              <Route component={Layout}>
                <Route path="/login" component={Login} />
                <Route path="/register" component={Register} />
                <Route path="/register-complete" component={RegisterComplete} />
                <Route path="/forgot" component={ForgotPassword} />
                <Route
                  path="/reset-gobiz-password"
                  component={ResetGoBizPassword}
                />
                <Route
                  path="/reset-gobiz-password-done"
                  component={ResetGoBizPasswordDone}
                />
                <Route
                  path="/reset-password/:token"
                  component={ResetPassword}
                />
                <Route
                  path="/success-reset-password"
                  component={SuccessResetPassword}
                />
                <Route
                  path="/success-forgot-password"
                  component={SuccessForgotPassword}
                />
                <Route path="/resend" component={ResendVerificationEmail} />
                <Route path="/verify-email/:token" component={VerifyEmail} />
              </Route>
            </Router>
          </UnleashFeatureFlagProvider>
        </FeatureFlagProvider>
      </Provider>
    );
  }
}

export default App;
